<template>
  <div>
    <b-row>
      <b-col>
        <vs-card>
          <b-row align-v="center">
            <b-col lg="1" sm="12">
              <label for="datepicker-sm">Tarih: </label></b-col
            >
            <b-col lg="3" sm="5">
              <b-form-datepicker
                id="datepickerbaslangic"
                v-model="datepickerbaslangic"
                local="en"
                today-variant="danger"
                placeholder="Tarih Seçimi"
                :start-weekday="weekday"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }"
              />
            </b-col>
            <b-col lg="2" sm="5">
              <v-select
                v-model="secilenZaman"
                :options="zamanList"
                label="name"
                style=""
                @input="getFinansalPlan()"
              >
              </v-select>
            </b-col>
            <b-col lg="2" sm="5">
              <vs-button
                style="border-radius: 5px; width: 100%"
                type="gradient"
                @click="getFinansalPlan"
                id="button-with-loading-yeni"
                class="vs-con-loading__container"
                >Listele</vs-button
              >
            </b-col>
            <b-col lg="3" sm="5">
              <vs-button
                style="border-radius: 5px; width: 100%"
                type="gradient"
                @click="cekPozisyon"
                color="success"
                >Çek Pozisyon Listesi</vs-button
              >
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <b-row style="height: 370px">
      <b-col>
        <vs-card>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :localeText="localeText"
            :pagination="true"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
            :pinnedBottomRowData="pinnedBottomRowData"
            :getRowStyle="getRowStyle"
          >
          </ag-grid-vue> </vs-card
      ></b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <vs-card>
          <div slot="header">
            <b-row>
              <b-col cols="3" style="padding-right: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 40px"
                    variant="warning"
                  >
                    <span class="mr-1"> </span>
                    <span style="font-size: 17px">DÖVİZ</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 40px">
                    <span style="font-size: 17px">{{ DOVIZ }} </span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="3" style="padding-left: 0; padding-right: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 40px"
                    variant="warning"
                  >
                    <span style="font-size: 17px">BORÇ</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 40px">
                    <span style="font-size: 17px">{{
                      currencyFormatter(BORC, "₺")
                    }}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="3" style="padding-left: 0; padding-right: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 40px"
                    variant="warning"
                  >
                    <span style="font-size: 17px">ALACAK</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 40px">
                    <span style="font-size: 17px">{{
                      currencyFormatter(ALACAK, "₺")
                    }}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="3" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 40px"
                    variant="warning"
                  >
                    <span style="font-size: 17px">VADE</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 40px">
                    <span style="font-size: 17px">{{
                      currencyFormatter(BAKIYE, "₺")
                    }}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </div></vs-card
        >
      </b-col>
      <b-col cols="6"></b-col>
    </b-row>
    <b-modal
      ref="modal-primary"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      title="Çek Pozisyon Listesi"
      hide-footer
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <b-row>
              <b-col>
                <p style="font-weight: 600;">Müşteri Çekleri</p>
                <vs-divider></vs-divider>
                <ag-grid-vue
                  style="width: 100%; height: 450px"
                  class="ag-theme-alpine"
                  :defaultColDef="defaultColDef"
                  :columnDefs="columnDefsCek"
                  :rowData="rowDataCek"
                  :localeText="localeText"
                  :pagination="true"
                  @grid-ready="onGridReady"
                  @first-data-rendered="onFirstDataRendered"
                >
                </ag-grid-vue>
              </b-col>
              <b-col>
                <p style="font-weight: 600;">Firma Çekleri</p>
                <vs-divider></vs-divider>
                <ag-grid-vue
                  style="width: 100%; height: 450px"
                  class="ag-theme-alpine"
                  :defaultColDef="defaultColDef"
                  :columnDefs="columnDefsFirma"
                  :rowData="rowDataFirma"
                  :localeText="localeText"
                  :pagination="true"
                  @grid-ready="onGridReady"
                  @first-data-rendered="onFirstDataRendered"
                >
                </ag-grid-vue>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
export default {
  components: {
    TextGorunumCellRenderer,
    AgGridVue,
    "v-select": vSelect
  },
  data() {
    return {
      weekday:1,
      DOVIZ: "",
      BORC: "",
      ALACAK: "",
      BAKIYE: "",
      TLODEME: 0.0,
      getRowStyle: null,
      columnDefsFirma: null,
      columnDefsCek: null,
      rowDataCek: null,
      rowDataFirma: null,
      eurTop: 0.0,
      tlTop: 0.0,
      usdTop: 0.0,
      tltahtop: 0.0,
      pinnedBottomRowData: null,
      rowData: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs: null,
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      secilenZaman: "",
      zamanList: [
        { name: "Günlük Liste", val: 2 },
        { name: "Haftalık Liste", val: 3 },
        { name: "Aylık Liste", val: 4 }
      ]
    };
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      //  this.rpAcikFaturalarDetay();
    },
    cekPozisyon() {
      this.$refs["modal-primary"].show();
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.INT_Cek_Pozisyon(args, function(err, result) {
          if (result.INT_Cek_PozisyonResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Cek_PozisyonResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.rowDataCek = list;
          } catch (error) {
            console.log(error);
          }
        });
      });
      soap.createClient(url, function(err, client) {
        client.INT_Firma_Cekleri(args, function(err, result) {
          if (result.INT_Firma_CekleriResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Firma_CekleriResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.rowDataFirma = list;
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    currencyFormatter(currency, sign) {
      if (currency != null) {
        var pscurr = parseFloat(currency);
        var sansDec = pscurr.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    getFinansalPlan() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      var seclist = vm.secilenZaman.name;
      if (typeof seclist == "undefined") seclist = "Günlük Liste";
      var seczam = moment(String(vm.datepickerbaslangic)).format("DD.MM.YYYY");
      if (seczam == "Invalid date") {
        var today = new Date();
        seczam = moment(String(today)).format("DD.MM.YYYY");
      }

      const args = {
        token: Store.state.tokenId,
        TARIH: seczam,
        LISTE: seclist
      };
      soap.createClient(url, function(err, client) {
        client.INT_Finans_Plan(args, function(err, result) {
          if (result.INT_Finans_PlanResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.eurTop = 0.0;
            vm.tlTop = 0.0;
            vm.usdTop = 0.0;
            vm.tltahtop = 0.0;
            vm.TLODEME = 0.0;

            vm.veriler = JSON.parse(result.INT_Finans_PlanResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.rowData = list;
              console.log(vm.rowData);
              list.forEach((val, index) => {
                if (val.EUR != null) vm.eurTop += val.EUR;
                if (val.TL != null) vm.tlTop += val.TL;
                if (val.USD != null) vm.usdTop += val.USD;
                if (val.TLTAHSILAT != null) vm.tltahtop += val.TLTAHSILAT;
                if (val.TLODEME != null) vm.TLODEME += val.TLODEME;
              });
              console.log(vm.TLODEME);
              vm.pinnedBottomRowData = vm.createData(1, "Bottom");
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              soap.createClient(url, function(err, client) {
                client.INT_Finans_Plan_Detay(args, function(err, result) {
                  if (result.INT_Finans_Plan_DetayResult == "-1") {
                    Store.dispatch("logout");
                    //this.$store.dispatch('login', payload)
                  }
                  try {
                    console.log(result);
                    vm.veriler2 = JSON.parse(
                      result.INT_Finans_Plan_DetayResult
                    );
                    var list2 = JSON.parse(vm.veriler2.jsonData);
                    vm.DOVIZ = list2[0].DOVIZ;
                    vm.BORC = list2[0].BORC;
                    vm.ALACAK = list2[0].ALACAK;
                    vm.BAKIYE = list2[0].BAKIYE;

                    console.log(list2);
                  } catch (error) {
                    console.log(error);
                  }
                });
              });
            } else {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },

    createData(count, prefix) {
      var result = [];

      result.push({
        TAHSILATGUN: "",
        VADE: "",
        EUR: this.eurTop,
        USD: this.usdTop,
        TL: this.tlTop,
        TLTAHSILAT: this.tltahtop,
        TLODEME: this.TLODEME,
        KREDINO: "",
        BANKAADI: "",
        ACIKLAMASI: ""
      });

      return result;
    }
  },

  created() {
    this.getFinansalPlan();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getRowStyle = params => {
      if (params.node.rowPinned) {
        return { "background-color": "#E9E9E9" };
      }
    };
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "İşlem Tarihi",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "TAHSILATGUN"
      },
      {
        headerName: "Vadesi",
        field: "VADE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "EUR Tutar",
        field: "EUR",
        sortable: true,
        filter: "agDateColumnFilter",
        cellClass: "rag-amber",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params => this.currencyFormatter(params.data.EUR, "€"),
        type: "rightAligned"
      },
      {
        headerName: "USD Tutar",
        field: "USD",
        sortable: true,
        filter: "agDateColumnFilter",
        cellClass: "rag-green",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params => this.currencyFormatter(params.data.USD, "$"),
        type: "rightAligned"
      },

      {
        headerName: "TL Tutar",
        field: "TL",
        sortable: true,
        cellClass: "rag-blue",
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params => this.currencyFormatter(params.data.TL, "₺"),
        type: "rightAligned"
      },
      {
        headerName: "TL Tahsilat Tutar",
        field: "TLTAHSILAT",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.TLTAHSILAT, "₺"),
        type: "rightAligned"
      },
      {
        headerName: "TL Ödeme Tutar",
        field: "TLODEME",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.TLODEME, "₺"),
        type: "rightAligned"
      },
      {
        headerName: "İşlem No",
        field: "KREDINO",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Banka",
        field: "BANKAADI",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true,
        cellRenderer: "TextGorunumCellRenderer"
      },
      {
        headerName: "Açıklama",
        field: "ACIKLAMASI",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true,
        cellRenderer: "TextGorunumCellRenderer"
      }
    ];
    this.columnDefsFirma = [
      {
        headerName: "Ay/Yıl",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "FYIL"
      },
      {
        headerName: "Satıcıda",
        field: "SATICIDA",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.SATICIDA, "₺"),
        type: "rightAligned"
      }
    ];
    this.columnDefsCek = [
      {
        headerName: "Ay/Yıl",
        sortable: true,
        filter: "agTextColumnFilter",
        cellClass: "rag-blue",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "YIL"
      },
      {
        headerName: "Teminatta",
        field: "TEMINATTA",
        sortable: true,
        filter: "agTextColumnFilter",
        cellClass: "rag-amber",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.TEMINATTA, "₺"),
        type: "rightAligned"
      },
      {
        headerName: "Kasada",
        field: "PORTFOY",
        sortable: true,
        filter: "agDateColumnFilter",
        cellClass: "rag-green",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.PORTFOY, "₺"),
        type: "rightAligned"
      },
      {
        headerName: "Toplam",
        field: "TOPLAM",
        sortable: true,
        filter: "agDateColumnFilter",

        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.TOPLAM, "₺"),
        type: "rightAligned"
      }
    ];
  }
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.rag-amber {
  background-color: lightsalmon;
}
.rag-blue {
  background-color: lightblue;
}
.rag-green {
  background-color: lightgreen;
}
</style>
